import type {
  CollectionAddOrderRequestType,
  CollectionAddOrderResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCollectionAddOrder = (collectionId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: CollectionAddOrderRequestType) =>
      apiV2Request({
        user,
        business,
        method: "put",
        path: `collection/${collectionId}/add-order`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as CollectionAddOrderResponseType,
      ),
    onSettled: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Collections,
          collectionId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Collections],
      });
    },
  });
};
